import { Connectivity_getInstance3vnm26551dbr1 as Connectivity_getInstance } from './fetch-connectivity.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { clockMillis2lf7cl1xsmoff as clockMillis } from './clockMillis.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { intercepted2ogpsikxxj4u0 as intercepted } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CancellableContinuationImpl.mjs';
import {
  Companion_instancejy2056q2ma5w as Companion_instance,
  _Result___init__impl__xyqfz832zdzqrocazzs as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import {
  ConnectionException1wjs7wwnknnfm as ConnectionException,
  RequestBlockedException1rsmv019vjn6n as RequestBlockedException,
} from './fetch.mjs';
import { delayp0o4nsccwai as delay } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  multiply2k9eolhnz1bjv as multiply,
  toNumber2e2hj9zugjwi2 as toNumber,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  orPromise1iucc2to2udt2 as orPromise,
  $3l5vvh8yg0ier as $,
} from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { toList3jhuyej2anx2q as toList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { get_AppScopes4bqeg21n0qw as get_AppScope } from '../../../../reactive/com/lightningkite/reactive/core/AppScope.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { get_isActivehakov5bm97hw as get_isActive } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { printStackTrace214c8iyv3cpiv5 as printStackTrace2 } from './debugger.js.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { SupervisorJobythnfxkr3jxc as SupervisorJob } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Supervisor.mjs';
import { reactive2xic0rufq5s8n as reactive } from '../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { take9j4462mea726 as take } from '../../../../kotlin-kotlin-stdlib/kotlin/text/_Strings.mjs';
import { report1vfr9zf0i9d9p as report } from './debugger.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function retryWebSocket(underlyingSocket, pingTime, gate, log) {
  gate = gate === VOID ? Connectivity_getInstance().fetchGate_1 : gate;
  log = log === VOID ? null : log;
  if (log == null)
    null;
  else {
    log.log_iyb52q_k$(['Creating']);
  }
  var lastConnect = {_v: 0.0};
  // Inline function 'kotlin.also' call
  var this_0 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(false);
  var it = this_0;
  it.addListener_6y9mct_k$(() => {
    var tmp0_safe_receiver = log;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.log_iyb52q_k$(['connected: ' + it.get_value_j01efc_k$()]);
    }
    return Unit_instance;
  });
  var connectedSignal = this_0;
  var current = new (CurrentSocket())();
  var onOpenList = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var onMessageList = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var onBinaryMessageList = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var onCloseList = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var lastPong = {_v: clockMillis()};
  return new (retryWebSocket$2())(connectedSignal, current, gate, underlyingSocket, log, onOpenList, lastPong, onMessageList, onBinaryMessageList, onCloseList, lastConnect, pingTime);
}
var CurrentSocketClass;
function CurrentSocket() {
  if (CurrentSocketClass === VOID) {
    class $ {
      constructor() {
        this.socket_1 = null;
        this.id_1 = -1;
        this.nextId_1 = 0;
      }
    }
    initMetadataForClass($, 'CurrentSocket', CurrentSocket);
    CurrentSocketClass = $;
  }
  return CurrentSocketClass;
}
function *waitUntilConnect(_this__u8e3s4, delay, $completion) {
  var tmp;
  if (delay === VOID) {
    tmp = waitUntilConnect$slambda();
  } else {
    tmp = delay;
  }
  delay = tmp;
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  (yield () => {
    var uCont = $completion;
    var cancellable = new (CancellableContinuationImpl())(intercepted(uCont), 1);
    cancellable.initCancellability_shqc60_k$();
    var it = cancellable;
    var alreadyResumed = {_v: false};
    _this__u8e3s4.onOpen_i39mgf_k$(() => {
      var tmp;
      if (!alreadyResumed._v) {
        alreadyResumed._v = true;
        // Inline function 'kotlin.coroutines.resume' call
        var this_0 = it;
        // Inline function 'kotlin.Companion.success' call
        var tmp$ret$5 = _Result___init__impl__xyqfz8(Unit_instance);
        this_0.resumeWith_rk9gbt_k$(tmp$ret$5);
        tmp = Unit_instance;
      }
      return Unit_instance;
    });
    _this__u8e3s4.onClose_nz13c7_k$((code) => {
      var tmp;
      if (!alreadyResumed._v) {
        alreadyResumed._v = true;
        var tmp0 = it;
        // Inline function 'kotlin.coroutines.resumeWithException' call
        // Inline function 'kotlin.Companion.failure' call
        var exception = ConnectionException().new_com_lightningkite_kiteui_ConnectionException_w8iu0n_k$('Socket closed almost immediately.  Code ' + code);
        var tmp$ret$7 = _Result___init__impl__xyqfz8(createFailure(exception));
        tmp0.resumeWith_rk9gbt_k$(tmp$ret$7);
        tmp = Unit_instance;
      }
      return Unit_instance;
    });
    return cancellable.getResult_fck196_k$();
  });
  return Unit_instance;
}
function typed(_this__u8e3s4, json, send, receive) {
  return new (typed$1())(_this__u8e3s4, json, receive, send);
}
function retryWebSocket$reset$lambda$slambda($pingTime, $id, $current, $lastPong, $socket) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    while (true) {
      yield* delay($pingTime, $completion);
      if (!($id === $current.id_1))
        return Unit_instance;
      var now = clockMillis();
      var tmp = $lastPong._v;
      // Inline function 'kotlin.Long.times' call
      var this_0 = $pingTime;
      var tmp$ret$0 = multiply(this_0, fromInt(3));
      if (tmp < now - toNumber(tmp$ret$0)) {
        $socket.close_a2oca2_k$(3000, 'Server did not respond to three consecutive pings.');
        return Unit_instance;
      } else {
        var tmp_0 = $lastPong._v;
        // Inline function 'kotlin.Long.times' call
        var this_1 = $pingTime;
        if (tmp_0 < now - toNumber(this_1) * 0.8) {
          $socket.send_oy6aea_k$(' ');
        }
      }
    }
    return Unit_instance;
  }), 1);
}
function *retryWebSocket$reset(current, $underlyingSocket, $log, onOpenList, lastPong, onMessageList, onBinaryMessageList, onCloseList, lastConnect, connectedSignal, $pingTime, $completion) {
  var _unary__edvuaz = current.nextId_1;
  current.nextId_1 = _unary__edvuaz + 1 | 0;
  var id = _unary__edvuaz;
  current.id_1 = id;
  var tmp0_safe_receiver = current.socket_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.close_a2oca2_k$(1000, 'Reconnecting');
  }
  var tmp = current;
  // Inline function 'kotlin.also' call
  var this_0 = yield* $($underlyingSocket($completion), $completion);
  var socket = this_0;
  var pings = {_v: null};
  socket.onOpen_i39mgf_k$(() => {
    var tmp;
    if (!(id === current.id_1)) {
      return Unit_instance;
    }
    var tmp0_safe_receiver = $log;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.log_iyb52q_k$(['' + id + ' onOpen']);
    }
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = toList(onOpenList).iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      element();
    }
    return Unit_instance;
  });
  socket.onMessage_u48dtp_k$((it) => {
    var tmp;
    if (!(id === current.id_1)) {
      return Unit_instance;
    }
    var tmp0_safe_receiver = $log;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.log_iyb52q_k$(['' + id + ' onMessage ' + it]);
    }
    lastPong._v = clockMillis();
    var tmp_0;
    // Inline function 'kotlin.text.isNotBlank' call
    if (!isBlank(it)) {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = toList(onMessageList).iterator_jk1svi_k$();
      while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
        var element = _iterator__ex2g4s.next_20eer_k$();
        element(it);
      }
      tmp_0 = Unit_instance;
    }
    return Unit_instance;
  });
  socket.onBinaryMessage_hcii77_k$((it) => {
    var tmp;
    if (!(id === current.id_1)) {
      return Unit_instance;
    }
    var tmp0_safe_receiver = $log;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.log_iyb52q_k$(['' + id + ' onBinaryMessage ' + toString(it)]);
    }
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = toList(onBinaryMessageList).iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      element(it);
    }
    return Unit_instance;
  });
  socket.onClose_nz13c7_k$((it) => {
    var tmp;
    if (!(id === current.id_1)) {
      return Unit_instance;
    }
    var tmp0_safe_receiver = $log;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.log_iyb52q_k$(['' + id + ' onClose ' + it]);
    }
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = toList(onCloseList).iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      element(it);
    }
    return Unit_instance;
  });
  socket.onOpen_i39mgf_k$(() => {
    var tmp;
    if (!(id === current.id_1)) {
      return Unit_instance;
    }
    lastConnect._v = clockMillis();
    lastPong._v = lastConnect._v;
    connectedSignal.set_value_v1vabv_k$(true);
    var tmp0_safe_receiver = pings._v;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.cancel$default_8haxne_k$();
    }
    var tmp_0 = get_AppScope();
    pings._v = launch(tmp_0, VOID, VOID, retryWebSocket$reset$lambda$slambda($pingTime, id, current, lastPong, socket));
    return Unit_instance;
  });
  socket.onClose_nz13c7_k$((it) => {
    var tmp;
    if (!(id === current.id_1)) {
      return Unit_instance;
    }
    var tmp0_safe_receiver = pings._v;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.cancel$default_8haxne_k$();
    }
    connectedSignal.set_value_v1vabv_k$(false);
    return Unit_instance;
  });
  tmp.socket_1 = this_0;
  return Unit_instance;
}
function retryWebSocket$o$lambda$slambda$slambda(this$0) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    yield* this$0.connectOnce_xysd9o_k$($completion);
    return Unit_instance;
  }), 0);
}
function retryWebSocket$o$lambda$slambda($log, $gate, this$0) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    $l$loop_0: while (get_isActive($this$launch)) {
      try {
        var tmp0_safe_receiver = $log;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.log_iyb52q_k$(['starting']);
        }
        yield* $gate.run_azsczg_k$('WS', retryWebSocket$o$lambda$slambda$slambda(this$0), $completion);
        var tmp1_safe_receiver = $log;
        if (tmp1_safe_receiver == null)
          null;
        else {
          tmp1_safe_receiver.log_iyb52q_k$(['started A']);
        }
        break $l$loop_0;
      } catch ($p) {
        if ($p instanceof RequestBlockedException()) {
          var e = $p;
          var tmp2_safe_receiver = $log;
          if (tmp2_safe_receiver == null)
            null;
          else {
            tmp2_safe_receiver.log_iyb52q_k$(['start blocked, not retrying: ' + e.toString()]);
          }
          break $l$loop_0;
        } else {
          if ($p instanceof CancellationException()) {
            var e_0 = $p;
            var tmp3_safe_receiver = $log;
            if (tmp3_safe_receiver == null)
              null;
            else {
              tmp3_safe_receiver.log_iyb52q_k$(['start cancelled: ' + e_0.toString()]);
            }
          } else {
            if ($p instanceof Exception()) {
              var e_1 = $p;
              var tmp4_safe_receiver = $log;
              if (tmp4_safe_receiver == null)
                null;
              else {
                tmp4_safe_receiver.log_iyb52q_k$(['start fail: ' + e_1.toString()]);
              }
              printStackTrace2(e_1);
              break $l$loop_0;
            } else {
              throw $p;
            }
          }
        }
      }
    }
    return Unit_instance;
  }), 1);
}
var retryWebSocket$2Class;
function retryWebSocket$2() {
  if (retryWebSocket$2Class === VOID) {
    class $ {
      constructor($connectedSignal, $current, $gate, $underlyingSocket, $log, $onOpenList, $lastPong, $onMessageList, $onBinaryMessageList, $onCloseList, $lastConnect, $pingTime) {
        this.$connectedSignal_1 = $connectedSignal;
        this.$current_1 = $current;
        this.$gate_1 = $gate;
        this.$underlyingSocket_1 = $underlyingSocket;
        this.$log_1 = $log;
        this.$onOpenList_1 = $onOpenList;
        this.$lastPong_1 = $lastPong;
        this.$onMessageList_1 = $onMessageList;
        this.$onBinaryMessageList_1 = $onBinaryMessageList;
        this.$onCloseList_1 = $onCloseList;
        this.$lastConnect_1 = $lastConnect;
        this.$pingTime_1 = $pingTime;
        this.listenerCounter_1 = 0;
        this.shouldBeOn_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(false);
        this.coroutineContext_1 = SupervisorJob();
        var attempt = {_v: null};
        reactive(this, VOID, ($this$reactive) => {
          var wanted = $this$reactive.invoke_r7m7el_k$(this.shouldBeOn_1);
          var isOn = $this$reactive.invoke_r7m7el_k$(this.get_connected_12bogw_k$());
          var tmp;
          if (wanted && !isOn) {
            var tmp_0;
            var tmp0_safe_receiver = attempt._v;
            if (!((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_isActive_quafmh_k$()) === true)) {
              attempt._v = launch($this$reactive, VOID, VOID, retryWebSocket$o$lambda$slambda($log, $gate, this));
              tmp_0 = Unit_instance;
            }
            tmp = tmp_0;
          } else if (!wanted && isOn) {
            var tmp1_safe_receiver = $current.socket_1;
            if (tmp1_safe_receiver == null)
              null;
            else {
              tmp1_safe_receiver.close_a2oca2_k$(1000, 'OK');
            }
            tmp = Unit_instance;
          }
          return Unit_instance;
        });
      }
      get_connected_12bogw_k$() {
        return this.$connectedSignal_1;
      }
      beginUse_omrbby_k$() {
        var _unary__edvuaz = this.listenerCounter_1;
        this.listenerCounter_1 = _unary__edvuaz + 1 | 0;
        if (_unary__edvuaz === 0) {
          this.shouldBeOn_1.set_value_v1vabv_k$(true);
        }
        return () => {
          var tmp;
          this.listenerCounter_1 = this.listenerCounter_1 - 1 | 0;
          if (this.listenerCounter_1 === 0) {
            this.shouldBeOn_1.set_value_v1vabv_k$(false);
            tmp = Unit_instance;
          }
          return Unit_instance;
        };
      }
      get_coroutineContext_115oqo_k$() {
        return this.coroutineContext_1;
      }
      *connectOnce_xysd9o_k$($completion) {
        try {
          yield* /*#__NOINLINE__*/retryWebSocket$reset(this.$current_1, this.$underlyingSocket_1, this.$log_1, this.$onOpenList_1, this.$lastPong_1, this.$onMessageList_1, this.$onBinaryMessageList_1, this.$onCloseList_1, this.$lastConnect_1, this.$connectedSignal_1, this.$pingTime_1, $completion);
          var tmp0_safe_receiver = this.$current_1.socket_1;
          if (tmp0_safe_receiver == null)
            null;
          else
            yield* /*#__NOINLINE__*/waitUntilConnect(tmp0_safe_receiver, this.$gate_1.delay_1, $completion);
        } catch ($p) {
          if ($p instanceof CancellationException()) {
            var e = $p;
            throw e;
          } else {
            if ($p instanceof ConnectionException()) {
              var e_0 = $p;
              throw e_0;
            } else {
              if ($p instanceof RequestBlockedException()) {
                var e_1 = $p;
                throw e_1;
              } else {
                if ($p instanceof Exception()) {
                  var e_2 = $p;
                  throw ConnectionException().new_com_lightningkite_kiteui_ConnectionException_w8iu0n_k$('Could not open the socket: ' + e_2.message, e_2);
                } else {
                  throw $p;
                }
              }
            }
          }
        }
        return Unit_instance;
      }
      close_a2oca2_k$(code, reason) {
        var tmp0_safe_receiver = this.$log_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.log_iyb52q_k$(['close ' + code]);
        }
        var closing = this.$current_1.socket_1;
        this.$current_1.socket_1 = null;
        this.$current_1.id_1 = -1;
        if (closing == null)
          null;
        else {
          closing.close_a2oca2_k$(code, reason);
        }
        if (this.$connectedSignal_1.get_value_j01efc_k$()) {
          this.$connectedSignal_1.set_value_v1vabv_k$(false);
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s = toList(this.$onCloseList_1).iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            element(code);
          }
        }
      }
      send_oy6aea_k$(data) {
        var tmp0_safe_receiver = this.$log_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.log_iyb52q_k$(['' + this.$current_1.id_1 + ' send ' + data]);
        }
        var tmp1_safe_receiver = this.$current_1.socket_1;
        if (tmp1_safe_receiver == null)
          null;
        else {
          tmp1_safe_receiver.send_oy6aea_k$(data);
        }
      }
      send_lirmaz_k$(data) {
        return this.send_oy6aea_k$((!(data == null) ? typeof data === 'string' : false) ? data : THROW_CCE());
      }
      onOpen_i39mgf_k$(action) {
        this.$onOpenList_1.add_utx5q5_k$(action);
      }
      onMessage_u48dtp_k$(action) {
        this.$onMessageList_1.add_utx5q5_k$(action);
      }
      onMessage_68111k_k$(action) {
        return this.onMessage_u48dtp_k$(action);
      }
      onBinaryMessage_hcii77_k$(action) {
        this.$onBinaryMessageList_1.add_utx5q5_k$(action);
      }
      onClose_nz13c7_k$(action) {
        this.$onCloseList_1.add_utx5q5_k$(action);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [0]);
    retryWebSocket$2Class = $;
  }
  return retryWebSocket$2Class;
}
function waitUntilConnect$slambda() {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    yield* delay(it, $completion);
    return Unit_instance;
  }), 1);
}
var typed$1Class;
function typed$1() {
  if (typed$1Class === VOID) {
    class $ {
      constructor($this_typed, $json, $receive, $send) {
        this.$this_typed_1 = $this_typed;
        this.$json_1 = $json;
        this.$receive_1 = $receive;
        this.$send_1 = $send;
      }
      get_connected_12bogw_k$() {
        return this.$this_typed_1.get_connected_12bogw_k$();
      }
      beginUse_omrbby_k$() {
        return this.$this_typed_1.beginUse_omrbby_k$();
      }
      close_a2oca2_k$(code, reason) {
        return this.$this_typed_1.close_a2oca2_k$(code, reason);
      }
      onOpen_i39mgf_k$(action) {
        return this.$this_typed_1.onOpen_i39mgf_k$(action);
      }
      onClose_nz13c7_k$(action) {
        return this.$this_typed_1.onClose_nz13c7_k$(action);
      }
      onMessage_68111k_k$(action) {
        this.$this_typed_1.onMessage_u48dtp_k$((it) => {
          var tmp;
          try {
            tmp = action(this.$json_1.decodeFromString_jwu9sq_k$(this.$receive_1, it));
          } catch ($p) {
            var tmp_0;
            if ($p instanceof CancellationException()) {
              var e = $p;
              tmp_0 = Unit_instance;
            } else {
              if ($p instanceof Exception()) {
                var e_0 = $p;
                report(Exception().new_kotlin_Exception_9qyiel_k$('Failed to decode message; expected a ' + this.$receive_1.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$() + " but got '" + take(it, 150) + "'", e_0));
                tmp_0 = Unit_instance;
              } else {
                throw $p;
              }
            }
            tmp = tmp_0;
          }
          return Unit_instance;
        });
      }
      send_lirmaz_k$(data) {
        this.$this_typed_1.send_oy6aea_k$(this.$json_1.encodeToString_k0apqx_k$(this.$send_1, data));
      }
    }
    initMetadataForClass($);
    typed$1Class = $;
  }
  return typed$1Class;
}
//region block: exports
export {
  retryWebSocket as retryWebSocket1zhkddxzq5149,
  typed as typedkoq3bdobhtfj,
};
//endregion

//# sourceMappingURL=wsretry.mjs.map
